<template>
  <div
    class="k-chip-button"
    :class="{
      'k-chip-button--block': block,
    }"
    :style="{
      border: `1px solid ${color}`,
      color,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ChipButton",
  props: {
    color: {
      type: String,
      default: "#F14536",
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.k-chip-button {
  padding: 6px 23px;
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: 16.41px;
  border: 1px solid $colorRed;
  text-align: center;
  width: 120px;
  height: 28px;
  border-radius: 2px;

  &--block {
    width: 100%;
  }
}
</style>
